import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=5d3c90ff&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d3c90ff')) {
      api.createRecord('5d3c90ff', component.options)
    } else {
      api.reload('5d3c90ff', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=5d3c90ff&", function () {
      api.rerender('5d3c90ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4MnTIMwz9AyeA/JS/comp/FavElement.vue"
export default component.exports